export default function HouseService(
    $http,
    DummyApi,
    $q,
    $filter,
    $location,
    API_LEGACY,
    $rootScope,
    API_SERVER
) {
    var oHouseService = {
        // HOUSE OBJECTS
        housecategorieslight: null,
        houseTypesActivityMapping: null,
        housecategories: null,
        housetypes: null,
        // housetypesgrouped: null,
        housetypeslight: [],
        firstLoad: true,
        selectedHouse: {},
        selectedActivity: {},
        searchResults: {},

        housesInline: {
            parentLanes: null,
        },

        // findHouseInline: function (lookUpID) {
        //     var houseInfo = null;

        //     angular.forEach(oHouseService.housesInline, function (item) {
        //         if (item.ID == lookUpID) {
        //             houseInfo = item;
        //         }
        //     });
        //     return houseInfo;
        // },

        // SEARCHFILTER
        searchFilter: {
            // searchStartDate: null, // dd-MM-yyyy
            // searchEndDate: null, // dd-MM-yyyy

            // searchStartTime: null, // 6-23
            // searchEndTime: null, // 6-23

            startDate: $filter("date")(Date.now(), "dd-MM-yyyy"),
            startDateDayOfWeek: {},

            startTime: 0, // will mutate in application -- ((new Date().getHours() + 1 < 23) ? new Date().getHours() + 1 : 0),

            // endDate: $filter("date")(
            //     moment().add(1, "days").format(),
            //     "dd-MM-yyyy"
            // ),

            endTime: -1, //((new Date().getHours() + 1 < 23) ? new Date().getHours() + 3 : 4),
            hours: 1,
            scrollToSearchResults: true,
            // customerType: {
            //     Name: "",
            //     CustomerTypeID: 0
            // },
            houseCategory: {
                CategoryID: 0,
                ChildCategories: null,
                Level: 0,
                Name: "Alle aktiviteter",
                ParentID: 0,
                Searchable: false,
                ThumbURL: "",
                type: "activity",
            },
            houseType: {
                ID: -1,
                Name: "Alle steder",
                type: "location",
            },
            //parentId: -1,
            selectedFilter: -1, // could this be deleted?
            selectedTimeObj: {}, // mobiscroll ussage
            searchNow: function () {
                // broadcast to search controller
                $rootScope.$broadcast("search-now-broadcast");
            },
            getDefaultFromHouseArray: function (array) {
                return $filter("filter")(array, function (c) {
                    return c.CategoryID <= 0;
                })[0];
            },
            syncSearchBar: function (house) {
                // broadcast to the search-bar directive
                $rootScope.$broadcast("sync-searchbar-broadcast", house);
            },
        },

        // CALENDER FILTER
        calenderFilter: {
            businessHoursRange: [
                0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                18, 19, 20, 21, 22, 23,
            ],
            getTodayDate: function () {
                var nowDate = $filter("date")(Date.now(), "dd-MM-yyyy");

                return nowDate;
            },
            latestStartHour: function () {
                return this.businessHoursRange.slice(-2)[0]; // return second last in array
            },
            latestEndHour: function () {
                return this.businessHoursRange.slice(-1)[0]; // return second last in array
            },
            startDate: function () {
                var date = Date.now();

                // IF user visits AFTER BEDTIME (last available booking) but still same day!

                // ( MIDNIGHT DATE BUG could be here -> getNowHour needs + 1 ???? )
                if (this.getNowHour() >= this.latestStartHour()) {
                    // get date of Tomorrow
                    var currentDate = new Date();
                    currentDate.setDate(currentDate.getDate() + 1);
                    var dateTomorrow = $filter("date")(
                        currentDate,
                        "dd-MM-yyyy"
                    ); // ex: 17-01-2017

                    date = dateTomorrow;
                }

                // date = '14-06-2017';

                return $filter("date")(date, "dd-MM-yyyy"); // ex: 17-01-2017
            },
            getNowHour: function () {
                var nowHour = new Date().getHours();

                // nowHour =  22 // test overwrite

                return nowHour;
            },
            datepickerMinDate: function () {
                // jQuery UI datepicker - set startdate in calender
                var minDate = "-0D";

                if (this.getNowHour() >= this.latestStartHour()) {
                    minDate = 1; // add one day to startDate
                }

                return minDate;
            },
            startTime: function () {
                // if not today

                // console.log(
                //     oHouseService.searchFilter.startDate +
                //         "!=" +
                //         this.getTodayDate()
                // );
                if (
                    oHouseService.searchFilter.startDate != this.getTodayDate()
                ) {
                    // returns first available time
                    return this.businessHoursRange[0];
                }
                // TO DO ::: MEDIUM ::: What happen if user visits after midnight, and wants to book a period belonging to this night ?

                // if user visits before before businessHoursRange[0]
                if (this.getNowHour() + 1 < this.businessHoursRange[0]) {
                    return this.businessHoursRange[0];
                }

                return this.getNowHour() + 1 < 23 ? this.getNowHour() + 1 : 0;
            },
            endTime: function () {
                // if not today
                if (this.startDate() != this.getTodayDate()) {
                    // returns first available time
                    return this.businessHoursRange[1];
                }

                var endTime = this.getNowHour() + 1;

                var defaultBookingRange = 3; // + 4 hours

                // if user visits before opening hours
                if (endTime < this.businessHoursRange[1]) {
                    return this.businessHoursRange[1] + defaultBookingRange;
                }

                // if user visits within opening hours
                if (endTime < this.latestEndHour()) {
                    endTime = endTime + defaultBookingRange; // add default booking hours
                }

                // if endtime gets higher than latest Business End Hour. ( kl 23.)
                if (endTime > this.latestEndHour()) {
                    endTime = this.latestEndHour(); // set endtime to (kl 23.)
                }

                return endTime;
            },
            checkSelectedHours: function (startTime, endTime) {
                if (this.getNowHour() > startTime) {
                    //console.log('You are confused, Dude');
                }

                if (endTime <= startTime) {
                    //console.log('endTime is negative');
                }

                //console.log(endTime);
            },
            findRestOfDayHours: function (selectedDate) {
                var availableHours = [];

                // if UNDEFINED set today
                if (selectedDate == null) {
                    selectedDate = this.startDate();
                }

                // IF TODAY ( ! FIX THIS !!!  Day change fails HERE !!!! )
                if (selectedDate == this.getTodayDate()) {
                    // Rest Of Day Hours Available - Business Logic
                    var restOfTodayHours = []; //tmp array

                    // CALCULATE AVAILABLE HOURS
                    for (
                        var i = this.businessHoursRange.length - 1;
                        i >= 0;
                        i--
                    ) {
                        if (
                            this.getNowHour() + 1 <=
                            this.businessHoursRange[i]
                        ) {
                            restOfTodayHours.push(this.businessHoursRange[i]);
                        }
                    }

                    availableHours = restOfTodayHours.reverse();
                    //console.log(restOfTodayHours);
                }

                // IF NOT TODAY
                if (selectedDate != this.getTodayDate()) {
                    // RETURN ALL AVAILABLE TIMES
                    availableHours = this.businessHoursRange;
                }

                return availableHours;
            },
            startHours: function (selectedDate) {
                // if no param is passed = today

                var availableHours = this.findRestOfDayHours(selectedDate);
                availableHours = availableHours.slice(0, -1); // remove last item/hour

                return availableHours;
            },
            endHours: function (selectedDate) {
                var availableHours = this.findRestOfDayHours(selectedDate);
                availableHours = availableHours.slice(1); //remove first item/hour
                return availableHours;
            },

            availableStartHours: null,
            availableEndHours: null,
            selectedStartTime: null,
            selectedEndTime: null,
            selectedDate: null,
        },
        currentHouse: {
            bookingMinPrice: 0,
        },

        getHouse: function (houseId) {
            var url = API_LEGACY + "/House/GetHouse/" + houseId;

            return $http.post(url).then(function (result) {
                return result.data;
            });
        },
        getActivitiesHierachical: function () {
            if (DummyApi.isEnabled()) {
                return $q.resolve(DummyApi.getActivitiesHierachical());
            }

            var service = this;
            var url = API_LEGACY + "/House/GetHouseCategories/";
            return $http.post(url).then(function (result) {
                result.data = service.addTypeToHouses(result.data, "activity");
                return result.data;
            });
        },

        getActivitiesNew: function () {
            var url = `${API_SERVER}/activities/active-activities`;
            const headers = {
                endpointType: "noTokenRequired",
            };
            return $http.get(url, { headers: headers }).then(function (result) {
                return result.data;
            });
        },

        /**
         * get a non hierachical list of activities
         */
        getActivities: function () {
            if (DummyApi.isEnabled()) {
                return $q.resolve(DummyApi.getActivities());
            }

            var service = this;
            var url = API_LEGACY + "/House/GetHouseCategoriesLight/";
            return $http.get(url, { cache: true }).then(function (result) {
                result.data = service.addTypeToHouses(result.data, "activity");

                return result.data;
            });
        },

        getResources: function (activityId) {
            var url = `${API_SERVER}/resources?activity_id=${activityId}&expand=location`;
            const headers = {
                endpointType: "noTokenRequired",
            };
            return $http.get(url, { headers: headers }).then(function (result) {
                return result.data;
            });
        },

        searchResult: function (start, end, activityId) {
            var url = `${API_SERVER}/search?start=${start}&end=${end}&activityId=${activityId}`;
            const headers = {
                endpointType: "noTokenRequired",
            };
            return $http.get(url, { headers: headers }).then(function (result) {
                return result.data;
            });
        },

        getHousesInline: function (aOfParentHouseIDs) {
            var url = API_LEGACY + "/House/GetHousesInline/";

            return $http.post(url, aOfParentHouseIDs).then(function (result) {
                return result.data;
            });
        },
        getHousesByCategory: function () {
            var url =
                API_LEGACY +
                "/House/GetHousesByCategory/" +
                this.searchFilter.customerType.CustomerTypeID;
            return $http.post(url, { cache: true }).then(function (result) {
                return result.data;
            });
        },
        getLocationsActivityMapping: function () {
            if (DummyApi.isEnabled()) {
                return $q.resolve(DummyApi.getLocationActivityMapping());
            }

            var url = API_LEGACY + "/House/GetHouseTypesActivityMapping/";
            return $http.post(url).then(function (result) {
                return result.data;
            });
        },
        // ensureProperStartTimeIsSet: function () {
        //     // console.log("ensureProperStartTimeIsSet");

        //     console.log(
        //         this.searchFilter.startDate +
        //             " !== " +
        //             this.calenderFilter.getTodayDate()
        //     );

        //     if (
        //         this.searchFilter.startDate !==
        //         this.calenderFilter.getTodayDate()
        //     ) {
        //         this.searchFilter.startTime = this.calenderFilter.businessHoursRange[0];
        //     }
        // },

        getSearchResult: function (userId) {
            // this.ensureProperStartTimeIsSet();

            var url =
                API_LEGACY +
                "/HouseResults/HallParentSearchGrouped/" +
                $filter("date")(this.searchFilter.startDate, "dd-MM-yyyy") +
                "/" +
                this.searchFilter.houseCategory.CategoryID +
                "/" +
                this.searchFilter.houseType.ID +
                "/" +
                0 + //this.searchFilter.startTime + // api return all day anyways
                "/" +
                0 + //this.searchFilter.endTime + // api return all day anyway
                "/0" + // //this.searchFilter.hours + // duration
                "/" +
                userId +
                "/0" + // antal personer - must be set, but not in use!
                "/?t=" +
                new Date().getTime(); // t=? to prevent caching

            // Json dummy response - saved to file (outdated)
            // return $http
            //     .get('http://kkdev.ubahn.dk/frontend/search-dummy.json')
            //     .then(function(result) {
            //         return result.data;
            //     });

            return $http.post(url).then(function (result) {
                result.data = oHouseService.addViewtypeToHouses(result.data);

                return result.data;
            });
        },
        addViewtypeToHouses: function (data) {
            var type;

            if (data.ViewType == 1) {
                type = "activity";
            }

            if (data.ViewType == 2) {
                type = "location";
            }

            if (data.ViewType == 3) {
                type = "period";
            }

            angular.forEach(data.GroupingInfos, function (value) {
                value.type = type;
            });

            return data;
        },
        addTypeToHouses: function (houses, sType) {
            angular.forEach(houses, function (value) {
                value.type = sType;
            });

            return houses;
        },
        getSearchGroupedNextResult: function () {
            var url =
                API_LEGACY +
                "/HouseResults/HallParentSearchGroupedNextResult/" +
                $filter("date")(this.searchFilter.startDate, "dd-MM-yyyy") +
                "/" +
                this.searchFilter.houseCategory.CategoryID + // activity
                "/" +
                this.searchFilter.houseType.ID + // location
                "/" +
                this.searchFilter.startTime +
                "/" +
                this.searchFilter.endTime +
                "/" +
                this.searchFilter.hours + // duration
                "/?t=" +
                new Date().getTime(); // t=? to prevent caching

            return $http.post(url, { cache: false }).then(function (result) {
                //return result.data.ParentLanes;
                result.data = oHouseService.addViewtypeToHouses(result.data);

                return result.data;
            });
        },
        getLaneHourWeekPrices: function (houseId) {
            var url =
                API_LEGACY +
                "/HouseResults/LaneHourWeekPrices/" +
                $filter("date")(this.searchFilter.startDate, "dd-MM-yyyy") +
                "/" +
                houseId;
            return $http.post(url, { cache: true }).then(function (result) {
                return result.data;
            });
        },
        getLocations: function () {
            var service = this;

            if (DummyApi.isEnabled()) {
                return $q.resolve(DummyApi.getLocations());
            }

            var url = API_LEGACY + "/House/GetHouseTypes/";
            return $http.post(url).then(function (result) {
                result.data = service.addTypeToHouses(result.data, "location");

                return result.data;
            });
        },
        getLocationsHierachical: function () {
            if (DummyApi.isEnabled()) {
                return $q.resolve(DummyApi.getLocationsHierachical());
            }

            var url = API_LEGACY + "/House/GetHouseTypesGrouped/";
            return $http.post(url).then(function (result) {
                return result.data;
            });
        },
        // getHouseTypesFlat: function () {
        //     var service = this;

        //     var url = API_LEGACY + "/House/GetHouseTypesGrouped/";
        //     return $http.post(url, { cache: false }).then(function (result) {
        //         result.data = service.flattenHouseTypes(result.data);

        //         return result.data;
        //     });
        // },
        flattenHouseTypes: function (data) {
            // CREATE A FLAT ARRAY OF HOUSETYPES - Refactor to API ?

            var houseTypesLight = [];

            angular.forEach(data, function (cat) {
                houseTypesLight.push(cat);

                angular.forEach(cat.ChildCategories, function (childCat) {
                    houseTypesLight.push(childCat);
                });
            });
            return houseTypesLight;
        },

        // getStartTime: function () {
        //     return new Date().getHours() + 1;
        // },

        overviewFilter: {
            alla: [],
            searchType: 1, // {SearchType} - Aktivitet = 1, location = 2
            houseCategoryID: 0,
            houseTypeID: 0,
            selectedHouse: {},
            getItemsCombo: function (searchType, activityId, locationId) {
                // api/HouseResults/AssetInformationGrouped/{SearchType}/{CategoryIDs}
                // SearchType 1=Alle aktiviteter, 2=Anlæg
                // CategoryIDs (aktiviteter) bruges, hvis SearchType = 1, og sættes til "0" for at få alle anlæg, eller f.eks. "75" for mødelokaler og arrangementer. Det er muligt at bruge flere aktiviteter, med kommaseperering (uden brug af mellemrum). F.eks. "75,76,77".
                // Returnerer det samme type objekt som HallParentSearchGrouped

                var url =
                    API_LEGACY +
                    "/HouseResults/AssetInformationGrouped/" +
                    searchType +
                    "/" + // {SearchType} - Aktivitet = 1, Anlæg = 2
                    activityId +
                    "/" + // {CategoryIDs} - 0 (all), 75,76,77
                    locationId + // {CategoryIDs} - 0 (all), 75,76,77
                    "/?t=" +
                    new Date().getTime(); // t=? to prevent caching

                return $http
                    .post(url, { cache: false })
                    .then(function (result) {
                        result.data = oHouseService.addViewtypeToHouses(
                            result.data
                        );

                        return result.data;
                    });
            },
            overviewNow: function (
                searchType,
                houseCategoryID,
                houseTypeID,
                path
            ) {
                // change Url to /overview
                $location.path(path); // instantiates overviewCtrl

                if (searchType) {
                    var args = {
                        searchType: searchType,
                        houseCategoryID: houseCategoryID,
                        houseTypeID: houseTypeID,
                    };

                    $rootScope.$broadcast(
                        "get-overview-results-broadcast",
                        args
                    ); // recieved in the overview controller!
                }
            },
        },
    };

    return oHouseService;
}
